import React, { useEffect } from "react";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";
import useWaterCoolerJoinMember from "hooks/useWaterCoolerJoinMember";
import useWaterCoolerLeftMember from "hooks/useWaterCoolerLeftMember";
import UserDefaultAvatar from "assets/img/user.svg";

export default ({ allMembersOnline, changeMembers, memberCount }) => {
  const { channelInformation } = useWaterCoolerContext();
  const joinMember = useWaterCoolerJoinMember({ channelInformation });
  const leftMember = useWaterCoolerLeftMember({ channelInformation });

  useEffect(() => {
    if (joinMember.member !== undefined) {
      changeMembers([...allMembersOnline, joinMember.member]);
    }
    //eslint-disable-next-line
  }, [joinMember.member]);

  useEffect(() => {
    if (leftMember.member !== undefined) {
      var allMembers = allMembersOnline.filter((data) => {
        return data.attributes.id !== leftMember.member.attributes.id;
      });
      changeMembers(allMembers);
    }
    //eslint-disable-next-line
  }, [leftMember.member]);

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  return (
    <div className="joined-users">
      {allMembersOnline?.slice(0, memberCount - 1).map((member, key) => (
        <React.Fragment key={key}>
          <img
            onError={checkSrc}
            src={member?.state?.attributes?.avatar ?? UserDefaultAvatar}
            alt={`${member?.state?.attributes?.avatar}`}
          />
        </React.Fragment>
      ))}

      {allMembersOnline.length >= memberCount && (
        <div className="stackedImage waterCoolerUserName">
          <div className="waterCoolerUserNoProfilePicture">
            {" "}
            +{allMembersOnline?.length + 1 - memberCount}{" "}
          </div>
        </div>
      )}
    </div>
  );
};
